export default __webpack_public_path__ + "assets/sauna-kit/sauna.aa3ad286e5971b82a998a3fb08d090a8.webp";